"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var guid_1 = require("../utils/guid");
var Context = (function () {
    function Context(container) {
        this.guid = guid_1.guid();
        this.container = container;
    }
    Context.prototype.addPlan = function (plan) {
        this.plan = plan;
    };
    Context.prototype.setCurrentRequest = function (currentRequest) {
        this.currentRequest = currentRequest;
    };
    return Context;
}());
exports.Context = Context;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inversify/lib/planning/context.js
// module id = L6y9
// module chunks = 0